import React, {useMemo} from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import './../chart.scss';
import Select from 'react-select';
import {useTranslation} from '../../../hooks/useTranslation';

const TinyBarChart = ({
  size = 'small',
  data,
  title,
  options,
  handlePeriodChange,
  width = '',
  isTime = false,
}) => {
  const {t} = useTranslation();

  const {newData, unit} = useMemo(() => {
    const empty = {
      newData: [],
      unit: isTime ? ` ${t('components.seconds')}` : '',
    };
    if (!data?.some(item => item?.value)) return empty;
    if (!isTime) return {newData: data, unit: ''};
    return {
      newData: data?.map(item => ({
        ...item,
        value: Number((item.value / 60).toFixed(2)),
      })),
      unit: ` ${t('components.minutes')}`,
    };
  }, [data, isTime, t]);

  return (
    <div className={`chart mid ${width}`}>
      <div className='chart__header'>
        <p className='chart__header-title'>{title}</p>
        {(size === 'small' || size === 'small-mid') && (
          <Select
            defaultValue={options[0]}
            options={options}
            placeholder={t('components.selectType')}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                width: 135,
                height: 30,
                fontSize: 14,
                backgroundColor: '#FFFFFF',
                color: '#718096',
              }),
            }}
            onChange={selected => {
              handlePeriodChange(selected.value);
            }}
          />
        )}
      </div>
      {newData?.length > 0 ? (
        <ResponsiveContainer height={size === 'small' ? 206 : 303} width='100%'>
          <BarChart
            height={size === 'small' ? 206 : 303}
            data={newData}
            barGap={size === 'small' ? 32 : 49}
          >
            <CartesianGrid
              strokeDasharray='1'
              vertical={size === 'small' ? false : true}
              horizontal={size === 'small'}
            />
            <Tooltip />
            <XAxis
              dataKey='key'
              stroke='rgba(0, 0, 0, 0.40)'
              tick={{fontSize: 14}}
            />
            <YAxis stroke='rgba(0, 0, 0, 0.40)' />
            <Bar
              dataKey='value'
              unit={unit}
              name={title}
              fill='#548CC5'
              barSize={size === 'small' ? 18 : 40}
              radius={4}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div
          style={{
            width: '100%',
            height: '303px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <div className='expired__box-img' style={{margin: '0'}}>
              <img src='/assets/no-data.svg' alt='no-data' />
            </div>
            <p className='no-payment-text'>{t('chart.noData')}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TinyBarChart;
